import React, { useState, useEffect } from 'react';
import './PasswordModal.scss';

interface PasswordModalProps {
  isOpen: boolean;
  onPasswordCorrect: () => void;
}
const correctPassword = 'ilwall2026';

const PasswordModal: React.FC<PasswordModalProps> = ({ isOpen, onPasswordCorrect }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Disable scroll and prevent interaction when modal is open
  useEffect(() => {
    if (isOpen) {
      // Disable scroll
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '0';
      document.body.style.left = '0';
      document.body.style.width = '100%';
      
      // Prevent right-click context menu
      const preventContextMenu = (e: MouseEvent) => e.preventDefault();
      document.addEventListener('contextmenu', preventContextMenu);
      
      // Prevent keyboard shortcuts
      const preventKeyboard = (e: KeyboardEvent) => {
        // Allow only Tab, Enter, Escape, and alphanumeric keys
        const allowedKeys = ['Tab', 'Enter', 'Escape'];
        const isAlphanumeric = /^[a-zA-Z0-9]$/.test(e.key);
        
        if (!allowedKeys.includes(e.key) && !isAlphanumeric) {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', preventKeyboard);
      
      return () => {
        // Re-enable scroll
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.width = '';
        
        // Remove event listeners
        document.removeEventListener('contextmenu', preventContextMenu);
        document.removeEventListener('keydown', preventKeyboard);
      };
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password === correctPassword) {
      setError('');
      onPasswordCorrect();
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <div className="password-modal-content">
          <div className="password-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 8H20C20.5304 8 21.0391 8.21071 21.4142 8.58579C21.7893 8.96086 22 9.46957 22 10V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V10C2 9.46957 2.21071 8.96086 2.58579 8.58579C2.96086 8.21071 3.46957 8 4 8H6V6C6 4.4087 6.63214 2.88258 7.75736 1.75736C8.88258 0.632141 10.4087 0 12 0C13.5913 0 15.1174 0.632141 16.2426 1.75736C17.3679 2.88258 18 4.4087 18 6V8ZM8 8H16V6C16 4.93913 15.5786 3.92172 14.8284 3.17157C14.0783 2.42143 13.0609 2 12 2C10.9391 2 9.92172 2.42143 9.17157 3.17157C8.42143 3.92172 8 4.93913 8 6V8ZM12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14Z" fill="#4A90E2"/>
            </svg>
          </div>
          
          <h2 className="password-title">Password required</h2>
          
          <p className="password-description">
            You need a password to access the prototype WHT30 Page
          </p>
          
          <form onSubmit={handleSubmit} className="password-form">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter Password"
              className="password-input"
              autoFocus
            />
            
            {error && <div className="password-error">{error}</div>}
            
            <button type="submit" className="password-button">
              Continue
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
